import Vue, { DirectiveOptions } from 'vue';

let handleOutsideClick: any;

const clickOutside: DirectiveOptions = {
  bind (el, binding, vnode) {
    handleOutsideClick = (e: Event) => {
      const { handler, exclude } = binding.value;
      e.stopPropagation();
      let clickedOnExcludedEl: Boolean = false;
      exclude.forEach((refName: any) => {
        if (!clickedOnExcludedEl) {
          const excludedEl: any = vnode.context && vnode.context.$refs[refName];
          clickedOnExcludedEl = excludedEl && excludedEl.contains(e.target as HTMLElement);
        }
      });
      if (!el.contains(e.target as HTMLElement) && !clickedOnExcludedEl) {
        vnode.context && vnode.context[(handler as keyof Vue)]();
      }
    };
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
  },

  unbind () {
    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('touchstart', handleOutsideClick);
  },
};
export default clickOutside;
